import { useAppDispatch } from '@/store/hooks'
import { useGoToLessonSettings } from '@/features/editor/components/studio/useLessonLastBlock'
import {
  selectBlock,
  selectLesson,
  setContentLang,
  setDialogOpen,
  setSettingsLang,
  setSettingsTab,
} from '@/features/editor/editorSlice'
import type { CourseWithoutBlocks } from '@/types/course'
import type { Violation } from '@/features/moderation/types'
import { ViolationRow } from './ViolationRow'
import type { ViolationGo } from './violationPlace'

interface Props {
  course: CourseWithoutBlocks
  violations: Violation[]
  onNavigate: () => void
  /** Свой переход вместо встроенного (настройки курса: окно закрывается с flush,
   *  страница уходит в редактор). Встроенный — для окна публикации внутри редактора. */
  onGo?: (target: ViolationGo) => void
}

export const ViolationList = ({ course, violations, onNavigate, onGo }: Props) => {
  const dispatch = useAppDispatch()
  const goToLessonSettings = useGoToLessonSettings()
  const go = (target: ViolationGo) => {
    if (onGo) {
      onGo(target)
      return
    }
    onNavigate()
    if (target.kind === 'course') {
      dispatch(setSettingsLang(target.lang ?? null))
      // Вкладку — до открытия: диалог читает её при каждом открытии.
      if (target.tab) dispatch(setSettingsTab(target.tab))
      dispatch(setDialogOpen({ dialog: 'settingsOpen', open: true }))
      return
    }
    // Нарушение в английском поле — правка переключается на английский.
    if (target.lang) dispatch(setContentLang(target.lang))
    // selectLesson гасит выбранный блок — блок выбираем ПОСЛЕ него.
    // «Перейти» к уроку (не к блоку) — в настройки урока, а не на его экран.
    if (target.kind === 'lesson') {
      goToLessonSettings(target.lessonId)
      return
    }
    dispatch(selectLesson(target.lessonId))
    dispatch(selectBlock(target.blockId))
  }
  // Без своей прокрутки: вложенная полоса внутри облачка публикации второй
  // прокруткой в прокрутке мешала — список листается вместе с окном.
  return (
    <ul className="space-y-1">
      {violations.map((v, i) => (
        <li key={`${i}:${v.ref}`}>
          <ViolationRow violation={v} lessons={course.lessons} onGo={go} />
        </li>
      ))}
    </ul>
  )
}
